import Immutable from 'immutable';
import {
  GET_ITEMS_TO_ITINERARY,
  CLEAR_ITEMS_TO_ITINERARY,
  FLAG_ITEM_TO_ITINERARY_ACTIVITY,
  UPDATE_ITEM_TO_ITINERARY,
  DELETE_ITEM_FROM_ITINERARY,
  GET_ITEMS_TO_ITINERARY_BY_PARCEL,
  CLEAR_ITEMS_TO_ITINERARY_BY_PARCEL,
  UPDATE_ITEMS_TO_ITINERARY_BY_PARCEL,
} from '../../../actions/types/cargo';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    activity: Immutable.List(),
    items: Immutable.Map(),
  }),
  parcel: Immutable.Map({
    items: Immutable.Map(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_ITEM_TO_ITINERARY_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_ITEMS_TO_ITINERARY:
      return state.setIn(['current', 'items'], Immutable.Map(payload));
    case CLEAR_ITEMS_TO_ITINERARY:
      return state.setIn(
        ['current', 'items'],
        INITIAL_STATE.getIn(['current', 'items']),
      );
    case UPDATE_ITEM_TO_ITINERARY:
      return state.updateIn(['current', 'items', 'content'], (content) =>
        content.map((item) =>
          item.correlation === payload.correlation ? payload : item,
        ),
      );
    case DELETE_ITEM_FROM_ITINERARY:
      return state.updateIn(['current', 'items', 'content'], (content) =>
        content.filter((item) => item.correlation !== payload),
      );

    case GET_ITEMS_TO_ITINERARY_BY_PARCEL:
      return state.setIn(['parcel', 'items'], Immutable.Map(payload));

    case CLEAR_ITEMS_TO_ITINERARY_BY_PARCEL:
      return state.setIn(
        ['parcel', 'items'],
        INITIAL_STATE.getIn(['parcel', 'items']),
      );
    case UPDATE_ITEMS_TO_ITINERARY_BY_PARCEL:
      return state.updateIn(['parcel', 'items', 'content'], (content) =>
        content.filter(
          (item) => !payload.some((payloadItem) => payloadItem.id === item.id),
        ),
      );

    default:
      return state;
  }
};
